var React = require('react');

function NavLogo (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".aaa,.bbb{fill:#fff;}.bbb{font-size:24px;font-family:SegoeScript-Bold, Segoe Script;font-weight:700;color:#fff;}")),React.createElement("g",{"transform":"translate(-17 -19)","key":1},[React.createElement("path",{"className":"aaa","d":"M9.027,4.952A4.75,4.75,0,0,1,13.383,2c2.624,0,4.514,2.245,4.751,4.92a4.9,4.9,0,0,1-.154,1.86,8.222,8.222,0,0,1-2.506,4.179L9.027,18.711,2.689,12.958A8.221,8.221,0,0,1,.183,8.779,4.9,4.9,0,0,1,.029,6.92C.267,4.245,2.156,2,4.78,2A4.6,4.6,0,0,1,9.027,4.952Z","transform":"translate(26.644 30.528) rotate(-11)","key":0}),React.createElement("text",{"className":"bbb","transform":"translate(17 45)","key":1},React.createElement("tspan",{"x":"0","y":"0"},"LoveLettr"))])]);
}

NavLogo.defaultProps = {"width":"121","height":"38","viewBox":"0 0 121 38"};

module.exports = NavLogo;

NavLogo.default = NavLogo;
